export default "__VITE_ASSET__BkPrWFSz__"